<template>
  <el-form ref="searchForm" :inline="true" :rules="rules" class="searchBoxLine" :model="searchForm">
    <el-form-item label="项目名称:" prop="projectName">
      <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" />
    </el-form-item>
    <el-form-item label="销往国家/区域:" prop="soldCountry">
      <el-input v-model="searchForm.soldCountry" placeholder="请输入销往国家/区域" />
    </el-form-item>
    <el-form-item label="合同编号:" prop="contractNum">
      <el-input v-model="searchForm.contractNum" placeholder="请输入合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
    </el-form-item>
    <el-form-item label="合同时间:" prop="startCreateTime">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.startCreateTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.endCreateTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" :loading="Loading" @click="doSearch">
        搜索
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script type="es6">
import { mapState } from 'vuex';
export default {
  data () {
    var isBig = (rule, value, callback) => {
      if (value <= this.searchForm.startDistributionRatio) {
        callback(new Error('分配比例结束条件不能小于等于起始条件!'));
      } else {
        callback();
      }
    };
    return {
      Loading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startCreateTime) {
            let date = new Date(this.searchForm.startCreateTime);
            date.setDate(date.getDate());
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      rules: {
        endDistributionRatio: [
          { validator: isBig, trigger: 'blur' }
        ]
      }
    };
  },
  model: {
    prop: 'searchForm',
    event: 'change'
  },
  props: {
    searchForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList //  现销/赊销
    })
  },
  methods: {
    doSearch () {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.Loading = true;
          this.$emit('submit', '', (res) => {
            this.Loading = res;
          });
        } else {
          return false;
        }
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.endCreateTime = '';
      // this.searchForm.startDistributionRatio = '';
      this.doSearch();
    }
  },
  mounted () {
  }
};
</script>
<style lang="less"></style>
